import React from 'react';

import { styled, TextField } from '@mui/material';
import PropTypes from 'prop-types';

const TextField_Custom = styled(TextField)(({ theme }) => ({
  color: theme.palette.text.primary,
  background: theme.palette.background.primary,
  borderRadius: 8,
  maxHeight: 42,
  width: 320,
  '& .MuiOutlinedInput-root': {
    backgroundColor: theme.palette.background.primary,
    borderRadius: 8,
    height: 42,
    '& fieldset': {
      border: 0,
    },
    '&:hover fieldset': {
      border: 0,
      borderRadius: 8,
    },
    '&.Mui-focused fieldset': {
      border: `1px solid ${theme.palette.text.primary}`,
      borderRadius: 8,
    },
    '& input': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    '& input::placeholder': {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
  },
  '& .MuiInputAdornment-root': {
    paddingRight: 0,
    cursor: 'pointer',
    color: theme.palette.text.primary,
    '&:hover': {
      color: theme.palette.text.dark,
    },
  },
}));

const LoginTextField = ({
  className,
  type,
  value,
  placeholder,
  autoFocus,
  disabled,
  InputProps,
  onChange,
}) => (
  <TextField_Custom
    className={className}
    type={type}
    value={value || ''}
    placeholder={placeholder}
    autoFocus={autoFocus}
    disabled={disabled}
    InputProps={InputProps}
    onChange={onChange}
  />
);

LoginTextField.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  InputProps: PropTypes.object,
  onChange: PropTypes.func,
};

export default LoginTextField;
